export const apiVersionPrefix: string = "/api/v0";

export const loginAgentApiPath: string = `${apiVersionPrefix}/login/agent`;
export const loginCodeApiPath: string = `${apiVersionPrefix}/login/code`;
export const loginApiPath: string = `${apiVersionPrefix}/login`;
export const logoutApiPath: string = `${apiVersionPrefix}/logout`;

export const analyticsApiPrefix: string = `${apiVersionPrefix}/tracking`;
export const analyticsEventApi: string = `${analyticsApiPrefix}/event`;
